export default "__VITE_ASSET__Z883O8Fh__"